import React, { useEffect } from 'react';
import {Helmet} from "react-helmet";
import { useTranslation } from 'react-i18next';
import { SubLayout } from 'layouts';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export function SupportOutlet(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log(location.pathname);
    if (location.pathname === '/support') {
      navigate(`/support/qna`);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <meta name="keywords" content={t('meta.keywords.support')}/>
      </Helmet>

      <SubLayout h2="Support" moH2="Support" path1="Support" path2={location.pathname.split('/')[2] === 'qna' ? 'Q&A' : 'FAQ'}>
        <Outlet />
      </SubLayout>
    </>

  );
}
